module.exports = __webpack_public_path__ + "static/media/hot-tub.b9879b1a.svg";